import { get, getOr, set, omit, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  fetchInventoryItemSkus,
  addInventoryItemSku,
  deleteInventoryItemSku
} from '../../sagas/routines';

const initialState = {
  byItemId: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  saved: false,
  saving: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

export const fetchItemSkusHandler = routine => ({
  [routine.TRIGGER]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    byItemId: set(
      get('items.0.itemId', response),
      keyBy('id', response.items),
      state.byItemId
    )
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: set('fetching', false)
});

export const addItemSkuHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const { itemId, id } = response;
    return {
      ...state,
      saved: true,
      byItemId: {
        ...state.byItemId,
        [itemId]: { ...getOr({}, itemId, state.byItemId), [id]: response }
      }
    };
  },
  [routine.FAILURE]: (state, error) => set('savingError', error, state),
  [routine.FULFILL]: set('saving', false)
});

export const deleteItemSkuHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, deleting: true, deleted: false }),
  [routine.SUCCESS]: (state, { payload: { id, skuId } }) => ({
    ...state,
    deleted: true,
    byItemId: {
      ...state.byItemId,
      [id]: omit(skuId, state.byItemId[id])
    }
  }),
  [routine.FAILURE]: (state, { error }) => set('deletingError', error, state),
  [routine.FULFILL]: set('deleting', false)
});

export default createReducer(initialState, {
  ...fetchItemSkusHandler(fetchInventoryItemSkus),
  ...addItemSkuHandler(addInventoryItemSku),
  ...deleteItemSkuHandler(deleteInventoryItemSku)
});
